import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7","key":"svg-0"}],["path",{"d":"M3 21h18","key":"svg-1"}]]

/**
 * IconPlaneInflight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGxhbmUtaW5mbGlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE1IDExLjA4NWg1YTIgMiAwIDEgMSAwIDRoLTE1bC0zIC02aDNsMiAyaDNsLTIgLTdoM2w0IDciIC8+CiAgPHBhdGggZD0iTTMgMjFoMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/plane-inflight
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlaneInflight = createReactComponent('outline', 'plane-inflight', 'PlaneInflight', __iconNode);

export default IconPlaneInflight;